/**
 * Wishdoit Watch Promo Gift Card (Plan B)
 * One free promo gift card based on qualifying ACTIVE watch cart subtotal:
 *   shop-currency (USD) subtotal < threshold → $25 variant
 *   shop-currency (USD) subtotal ≥ threshold → $50 variant
 * Exactly one promo gift line (qty 1). Made free by Admin 100% automatic discount.
 *
 * IMPORTANT: /cart.js line amounts are in the customer's presentment currency.
 * Thresholds are configured in shop currency (USD). Always compare in shop USD.
 */
(function () {
  'use strict';

  var cfg = window.WishdoitGiftPromo;
  if (!cfg || !cfg.enabled) return;

  var VARIANT_25 = String(cfg.variant25 || '');
  var VARIANT_50 = String(cfg.variant50 || '');
  var SHOP_CURRENCY = String(cfg.shopCurrency || 'USD').toUpperCase();
  var THRESHOLD_CENTS = Math.round(Number(cfg.threshold || 300) * 100);
  var GIFT_FOR_KEY = 'cart';
  var QUALIFYING = {};
  (cfg.qualifyingProductIds || []).forEach(function (id) {
    QUALIFYING[String(id)] = true;
  });

  if (!VARIANT_25 || !VARIANT_50) {
    console.warn('[WishdoitGiftPromo] Missing gift variant IDs');
    return;
  }

  if (!(cfg.qualifyingProductIds || []).length) {
    console.warn(
      '[WishdoitGiftPromo] qualifyingProductIds is empty — check collection handle "' +
        (cfg.collectionHandle || '') +
        '" is published to Online Store and contains products'
    );
  }

  var lock = false;
  var queued = false;
  var giftOptOut = false;
  var lastQualifyingSig = '';
  var syncTimer = null;

  function cartUrl(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/?$/, '/') + path.replace(/^\//, '');
  }

  function isGiftPromo(item) {
    if (!item || !item.properties) return false;
    var v = item.properties._gift_promo;
    return v === '1' || v === 1 || v === true;
  }

  function isQualifyingWatch(item) {
    if (!item || isGiftPromo(item)) return false;
    if (item.gift_card) return false;
    return !!QUALIFYING[String(item.product_id)];
  }

  /** Presentment→shop conversion rate (shop * rate = presentment). */
  function presentmentRate() {
    try {
      if (window.Shopify && Shopify.currency && Shopify.currency.rate != null) {
        var rate = parseFloat(Shopify.currency.rate);
        if (isFinite(rate) && rate > 0) return rate;
      }
    } catch (e) {}
    return 1;
  }

  function cartCurrency(cart) {
    if (cart && cart.currency) return String(cart.currency).toUpperCase();
    try {
      if (window.Shopify && Shopify.currency && Shopify.currency.active) {
        return String(Shopify.currency.active).toUpperCase();
      }
    } catch (e) {}
    return SHOP_CURRENCY;
  }

  /**
   * Convert a presentment-currency subunit amount (cart.js cents) into shop
   * currency subunits (USD cents). Prefer explicit shop_money when present.
   */
  function toShopCents(presentmentCents, cart) {
    var currency = cartCurrency(cart);
    if (!currency || currency === SHOP_CURRENCY) {
      return Math.round(Number(presentmentCents) || 0);
    }
    var rate = presentmentRate();
    return Math.round((Number(presentmentCents) || 0) / rate);
  }

  function moneyAmountToShopCents(money) {
    if (!money) return null;
    if (typeof money === 'number') {
      // Heuristic: values >= 1000 are likely already subunits; smaller are major units.
      // Prefer string MoneyV2.amount path below when available.
      return Math.round(money);
    }
    if (typeof money.amount === 'string' || typeof money.amount === 'number') {
      var code = money.currency_code || money.currencyCode || SHOP_CURRENCY;
      if (String(code).toUpperCase() !== SHOP_CURRENCY) return null;
      return Math.round(Number(money.amount) * 100);
    }
    return null;
  }

  function lineAmountShopCents(item, cart) {
    if (!item) return 0;

    // Prefer shop-currency money objects if Ajax/Cart ever exposes them.
    var shopFromSet =
      moneyAmountToShopCents(item.shop_money) ||
      moneyAmountToShopCents(item.final_line_price_set && item.final_line_price_set.shop_money) ||
      moneyAmountToShopCents(item.line_price_set && item.line_price_set.shop_money) ||
      moneyAmountToShopCents(item.price_set && item.price_set.shop_money);
    if (shopFromSet != null) {
      // price_set.shop_money is unit price; scale by qty when source was price_set only.
      if (
        item.price_set &&
        item.price_set.shop_money &&
        !(item.final_line_price_set && item.final_line_price_set.shop_money) &&
        !(item.line_price_set && item.line_price_set.shop_money) &&
        !item.shop_money
      ) {
        return shopFromSet * Number(item.quantity || 1);
      }
      return shopFromSet;
    }

    var presentment;
    if (typeof item.final_line_price === 'number') presentment = item.final_line_price;
    else if (typeof item.line_price === 'number') presentment = item.line_price;
    else presentment = Number(item.price || 0) * Number(item.quantity || 0);

    return toShopCents(presentment, cart);
  }

  function qualifyingWatches(cart) {
    return (cart.items || []).filter(isQualifyingWatch);
  }

  function qualifyingSubtotalShopCents(watches, cart) {
    var sum = 0;
    watches.forEach(function (w) {
      sum += lineAmountShopCents(w, cart);
    });
    return sum;
  }

  function qualifyingSignature(watches, subtotalCents) {
    var parts = watches
      .map(function (w) {
        return String(w.key) + ':' + String(w.quantity);
      })
      .sort();
    return parts.join('|') + '@' + String(subtotalCents);
  }

  function desiredGift(cart) {
    var watches = qualifyingWatches(cart);
    var subtotal = qualifyingSubtotalShopCents(watches, cart);
    var sig = qualifyingSignature(watches, subtotal);

    if (sig !== lastQualifyingSig) {
      lastQualifyingSig = sig;
      giftOptOut = false;
    }

    if (!watches.length || subtotal <= 0) return null;
    if (giftOptOut) return null;

    return {
      watchKey: GIFT_FOR_KEY,
      variantId: subtotal < THRESHOLD_CENTS ? VARIANT_25 : VARIANT_50,
      quantity: 1,
      subtotalCents: subtotal
    };
  }

  function currentPromoGifts(cart) {
    return (cart.items || []).filter(isGiftPromo);
  }

  function fetchCart() {
    return fetch(cartUrl('cart.js'), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (r) {
      if (!r.ok) throw new Error('cart.js ' + r.status);
      return r.json();
    });
  }

  function postJson(path, body) {
    return fetch(cartUrl(path), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) {
          var msg = (data && (data.description || data.message)) || 'HTTP ' + r.status;
          throw new Error(msg);
        }
        return data;
      });
    });
  }

  function refreshCartUi() {
    document.dispatchEvent(
      new CustomEvent('on:cart:change', { bubbles: true, cancelable: false })
    );
    document.dispatchEvent(
      new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true })
    );
  }

  function scheduleSync(delay) {
    if (syncTimer) clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      syncTimer = null;
      sync();
    }, typeof delay === 'number' ? delay : 150);
  }

  function removeGiftLines(gifts) {
    var ops = Promise.resolve();
    gifts.forEach(function (gift) {
      ops = ops.then(function () {
        return postJson('cart/change.js', { id: gift.key, quantity: 0 });
      });
    });
    return ops;
  }

  function sync() {
    if (lock) {
      queued = true;
      return;
    }
    lock = true;
    queued = false;

    fetchCart()
      .then(function (cart) {
        var want = desiredGift(cart);
        var gifts = currentPromoGifts(cart);
        var matching = null;
        var extras = [];

        gifts.forEach(function (g) {
          if (
            want &&
            !matching &&
            String(g.variant_id) === String(want.variantId) &&
            Number(g.quantity) === 1
          ) {
            matching = g;
          } else {
            extras.push(g);
          }
        });

        var changed = extras.length > 0;
        var chain = removeGiftLines(extras);

        return chain.then(function () {
          if (!want) return changed;
          if (matching) return changed;

          return postJson('cart/add.js', {
            items: [
              {
                id: Number(want.variantId),
                quantity: 1,
                properties: {
                  _gift_promo: '1',
                  _gift_for: GIFT_FOR_KEY,
                  _gift_subtotal: String(want.subtotalCents)
                }
              }
            ]
          })
            .then(function () {
              return true;
            })
            .catch(function (err) {
              console.warn(
                '[WishdoitGiftPromo] cart/add.js failed — is gift product published to Online Store?',
                err && err.message ? err.message : err
              );
              throw err;
            });
        });
      })
      .then(function (didChange) {
        if (didChange) refreshCartUi();
      })
      .catch(function (err) {
        console.warn('[WishdoitGiftPromo]', err && err.message ? err.message : err);
      })
      .then(function () {
        lock = false;
        if (queued) sync();
      });
  }

  document.addEventListener(
    'click',
    function (evt) {
      var remove = evt.target && evt.target.closest && evt.target.closest('.cart-item__remove');
      if (!remove) return;
      var row = remove.closest('.cart-item');
      if (!row || !row.classList.contains('cart-item--gift-promo')) return;
      giftOptOut = true;
    },
    true
  );

  function onCartEvent() {
    scheduleSync(200);
  }

  document.addEventListener('on:cart:add', onCartEvent);
  document.addEventListener('on:cart:change', onCartEvent);
  document.addEventListener('on:cart:after-merge', onCartEvent);

  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var input = args[0];
      var url = typeof input === 'string' ? input : input && input.url ? input.url : '';
      return origFetch.apply(this, args).then(function (response) {
        if (url && /\/cart\/(add|change|clear|update)/.test(url)) {
          scheduleSync(250);
        }
        return response;
      });
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scheduleSync(0);
    });
  } else {
    scheduleSync(0);
  }

  /**
   * Do NOT paint $0 over gift rows. Shopify cart.js / Liquid final_* prices are source of truth.
   * Cosmetically forcing free hid BXGY failures (subtotal still included gift face value).
   */
  function giftLineIsFree(item) {
    if (!item) return false;
    if (typeof item.final_line_price === 'number') return item.final_line_price === 0;
    if (typeof item.line_price === 'number') return item.line_price === 0;
    return false;
  }

  function warnIfGiftNotDiscounted(cart) {
    currentPromoGifts(cart).forEach(function (g) {
      if (giftLineIsFree(g)) return;
      var disc = 0;
      if (typeof g.total_discount === 'number') disc = g.total_discount;
      else if (Array.isArray(g.line_level_discount_allocations)) {
        g.line_level_discount_allocations.forEach(function (a) {
          disc += Number((a && a.amount) || 0);
        });
      }
      console.warn(
        '[WishdoitGiftPromo] Promo gift line is NOT free in cart.js — automatic BXGY/100% discount missing. final_line_price=' +
          String(g.final_line_price) +
          ' total_discount=' +
          String(disc) +
          ' variant=' +
          String(g.variant_id)
      );
    });
  }

  function decorateGiftRows() {
    document.querySelectorAll('.cart-item').forEach(function (row) {
      var isPromo =
        row.classList.contains('cart-item--gift-promo') ||
        row.getAttribute('data-gift-promo') === '1' ||
        (row.className && row.className.indexOf('product-gift-card-watch-promo') !== -1) ||
        (row.textContent && row.textContent.indexOf('Gift Card – Watch Promo') !== -1);
      if (!isPromo) return;
      row.classList.add('cart-item--gift-promo');
      row.querySelectorAll('.wishdoit-gift-badge, .cart-item__gift-badge').forEach(function (el) {
        el.remove();
      });
      var qty = row.querySelector('.cart-item__quantity .quantity');
      if (qty) qty.style.display = 'none';
      // Prices stay whatever Liquid / cart drawer rendered from Shopify allocations.
    });
  }

  document.addEventListener('on:cart:change', function () {
    setTimeout(decorateGiftRows, 300);
  });
  document.addEventListener('on:cart:after-merge', function () {
    setTimeout(decorateGiftRows, 50);
  });
  document.addEventListener('dispatch:cart-drawer:refresh', function () {
    setTimeout(decorateGiftRows, 150);
  });
  setTimeout(decorateGiftRows, 500);

  // After each successful sync path, re-read cart and surface missing discount allocations.
  var origSyncThen = null;
  (function patchSyncVerify() {
    var _fetchCart = fetchCart;
    // Hook via schedule after refresh: listen cart change and verify.
    document.addEventListener('on:cart:change', function () {
      setTimeout(function () {
        fetchCart()
          .then(warnIfGiftNotDiscounted)
          .catch(function () {});
      }, 400);
    });
  })();

  // Expose helpers for draft-theme verification / console checks.
  try {
    window.WishdoitGiftPromoDebug = {
      shopCurrency: SHOP_CURRENCY,
      thresholdCents: THRESHOLD_CENTS,
      toShopCents: toShopCents,
      lineAmountShopCents: lineAmountShopCents,
      qualifyingSubtotalShopCents: qualifyingSubtotalShopCents,
      desiredGift: desiredGift,
      giftLineIsFree: giftLineIsFree,
      warnIfGiftNotDiscounted: warnIfGiftNotDiscounted
    };
  } catch (e) {}
})();
